import { DOMAIN } from "../../../../../var_env."
import { RequestResponsePattern } from "../../../../../types/Request"
import { HistoricoColeta } from "../Types/HistoricoColeta"
import { setHistoricoColeta, setRequestHistoricoColetaData, setRequestHistoricoColetaError, setRequestHistoricoColetaLoading, setRequestHistoricoColetaMessage } from "../Reducers/MonitoramentoReducer"
import { getApi } from "../../../../../utils/requestApi"

export default async function getIndustriaMonitorada(dispatch: Function, id: number, pag: number){
    try {
        dispatch(setRequestHistoricoColetaLoading())

        const endpoint = `${DOMAIN}/HistoricoColeta`
        const params = `/`
        const response: RequestResponsePattern<HistoricoColeta> = await getApi({ endpoint, params })
        
        if(response){
            dispatch(setRequestHistoricoColetaData(response))
            localStorage.setItem("MonitoramentoIndustria", JSON.stringify(response.listaResultados))
            if(!response.flagErro) dispatch(setHistoricoColeta(response.listaResultados))
            else throw new Error(response.listaMensagens[0])
        }else throw new Error('Erro na requisição')
    } catch (error: any) {
        console.log(error)
        dispatch(setRequestHistoricoColetaMessage(error.message ?? JSON.stringify(error)))
        dispatch(setRequestHistoricoColetaError())
    }
}